import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1)

import {findArticles} from '@/api/module/article';
import {useScanner} from '@/store/scanner';
import {ref, watch} from 'vue';
import Article from '@/model/Article';
import {useRoute} from 'vue-router';
import ArticleListItem from '@/components/Article/ArticleListItem.vue';
import Loading from '@/components/Loading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleList',
  setup(__props, { expose: __expose }) {

const scanner = useScanner();
const sWord = ref('');
const articles = ref<Article[]>([]);
const error = ref<Error | null>(null);
const loading = ref(false);
const scanning = ref(false);
const route = useRoute();

let currentSWord: string | null = null;

let debounceTimeout: number | null = null;

async function loadArticles() {
  if (debounceTimeout) clearTimeout(debounceTimeout);
  if (!sWord.value) return;
  if (currentSWord === sWord.value) return;
  currentSWord = sWord.value;

  loading.value = true;
  try {
    const [foundArticles] = await findArticles(sWord.value);

    articles.value = foundArticles.map((a) => Article.fromApi(a));

    if (articles.value.length == 1) {
      detail(articles.value[0]);
    }
  } catch (err: any) {
    error.value = err as Error;
  } finally {
    loading.value = false;
  }
}

function detail(item: Article) {
  router.push({name: 'article_info_detail', params: {id: `${item.ArtikelNr}`}}).catch(console.error);
}

scanner.addScanListener(async (event) => {
  if (scanning.value) return;
  scanning.value = true;

  sWord.value = event.data;

  scanning.value = false;
});

watch(sWord, () => {
  if (debounceTimeout) clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => loadArticles(), 500);
});

sWord.value = route.query.search as string ?? '';

const opened = ref<string | null>(null);

__expose({
  ArticleListItem,
  sWord,
  articles,
  error,
  loading,
  loadArticles,
  opened,
  toggleOpened: (id: string, val: boolean) => {
    if (id === opened.value && !val) return opened.value = null;
    if (val) opened.value = id;
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, {
      class: "py-1 bg-grey-lighten-4",
      fluid: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: sWord.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sWord).value = $event)),
          loading: loading.value,
          label: "Suchen",
          variant: "solo",
          onKeypress: _withKeys(loadArticles, ["enter"]),
          "hide-details": ""
        }, null, 8, ["modelValue", "loading"])
      ], undefined, true),
      _: 1
    }),
    (!loading.value && !error.value)
      ? (_openBlock(), _createBlock(_component_v_list, {
          key: 0,
          lines: "two",
          class: "pa-0 border-t"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: article.ArtikelNr
              }, [
                _createVNode(ArticleListItem, { article: article }, null, 8, ["article"]),
                _hoisted_1
              ], 64))
            }), 128))
          ], undefined, true),
          _: 1
        }))
      : (error.value)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 1,
            class: "py-1",
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(error), { module: error.value }, null, 8, ["module"])
            ], undefined, true),
            _: 1
          }))
        : (_openBlock(), _createBlock(Loading, { key: 2 }))
  ], 64))
}
}

})